/**
 * Frontend only combined permissions
 */
export enum DynamicPdmsPermissionEnum {
    INPUT_OUTPUTS_ACCESS = 'can_access_balance_module',
    CARE_PROCEDURES_ACCESS = 'can_access_care_procedures_module',
    TASK_LIST_ACCESS = 'can_access_task_list_module',
}
